import styled from "styled-components";
import { select } from "@hubper/theme";
import posed from "react-pose";

const FloatingBox = styled.div`
  background-color: white;
  display: inline-block;
  border-radius: ${select.radius("normal")};
  transform-origin: top left;
`;

export default posed(FloatingBox)({
  enter: {
    opacity: 1,

    scale: 1,
    x: ({ translate }: any) => translate.x,
    y: ({ translate }: any) => translate.y,
    boxShadow: "3px 3px 10px 0px rgba(0, 0, 0, 0.12)",
    transition: {
      boxShadow: {
        type: "spring",
        stiffness: 600,
        damping: 30
      },
      scale: {
        type: "spring",
        stiffness: 500,
        damping: 25
      },
      default: {
        duration: 80
      }
    },
    border: "1px solid rgba(0, 0, 0, 0.06)"
  },
  exit: {
    opacity: 0,
    x: ({ translate }: any) => translate.x,
    y: ({ translate }: any) => translate.y,
    scale: 0.98,
    transition: {
      duration: 100
    },
    boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.0)",
    border: "1px solid rgba(0, 0, 0, 0)"
  }
});
